<template>
    <tr :class="['clickable', { updated: isLastVisited(entity.id) }]" @click="goToDetail($event, entity.id)">
      <td class="no_padding drag_drop"><span></span></td>
      <td class="no_padding">
        <input type="checkbox"
               :id="entity.id"
               :value="entity.id"
               @click.stop
               @change="onChange"
               :checked="isChecked"
        />
        <label
            :for="entity.id"
            @click.stop
            v-translate>Vybrat
        </label>
      </td>
        <td :data-th="'Popis' | translate" class="first_data"><strong>{{ entity.description }}</strong></td>
        <td :data-th="'Počet naimportovaných mac adres' | translate" class="first_data">{{ entity.mac_addresses_count }}</td>
        <td :data-th="'Datum vytvoření' | translate" v-html="$_date_formatFull(entity.date_created)"></td>
      <td class="no_padding edit">
        <div class="edit_inner"><a
            v-if="$_deleteActionAllowed"
              class="btn btn_action btn_delete"
              :title="'Smazat' | translate"
              @click.prevent.stop="emitDeleteRegisteredMacAddressBatch">
            <translate class="translate">Smazat</translate>
          </a>
        </div>
      </td>
    </tr>
</template>

<script>
import rowActions from "@/components/mixins/row-actions"

	export default {
		name: "RegisteredMacAddressBatchRow",
    mixins: [rowActions],
		data() {
			return {
				moduleName: 'RegisteredMacAddressBatchRow',
			}
		},
		props: {
			entity: Object,
		},
		methods: {
			goToDetail(e, id) {
				this.$router.push({name: 'registeredMacAddressBatchDetail', params: {id: this.entity.id}})
			},
      emitDeleteRegisteredMacAddressBatch() {
        this.$emit('deleteRegisteredMacAddressBatch', String(this.entity.id))
      },
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/registeredMacAddress/RegisteredMacAddressBatchRow.vue